/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import getConfig from '../../../config';

export const SEARCH_TABS_CONSTANTS = {
	ALL_TAB: 'all',
	HELP_TAB: 'help',
	APPS_TAB: 'apps',
	STOCK_TAB: 'stock',
	YOUR_WORK_TAB: 'yourWork',
};

export const SEARCH_ICONS = {
	XD_ICON: 'https://public.adobecc.com/files/1USOT45MYISRGEBCEF3JHVA0VBWFFF/xd_XD_128.svg',
	FOLDER_ICON: 'https://public.adobecc.com/files/1USOT45MYISRGEBCEF3JHVA0VBWFFF/folder-search.png',
	UNKNOWN_ICON: 'https://public.adobecc.com/files/1USOT45MYISRGEBCEF3JHVA0VBWFFF/filetype_generic_128.svg',
	EMPTY_RESULTS_ICON: 'https://public.adobecc.com/files/1USOT45MYISRGEBCEF3JHVA0VBWFFF/empty icon.svg',
	LINK_OUT_ICON: 'https://public.adobecc.com/files/1USOT45MYISRGEBCEF3JHVA0VBWFFF/link_out_icon.svg',
	DEFAULT_IMAGE: 'https://assets-cdn.adobe.com/5c6b25e2307304f13b11f49d0219fb85.svg',
	EMPTY_LIBRARY: 'https://public.adobecc.com/files/1UAKTUIFZSADEZM4UHZ1ICJXCO3FFF/empty_library.png',
	COLLAB_ICON: 'https://public.adobecc.com/files/1UAKTUIFZSADEZM4UHZ1ICJXCO3FFF/Smock_UserGroup_18_N@2x.svg',
	CHEVRON:
		'https://public.adobecc.com/files/1USOT45MYISRGEBCEF3JHVA0VBWFFF/Smock_UiMillerColumnsChevronPrevious_6x10_N@1x (1).svg',
};

export const APPS = [
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/ps_cc_app_RGB.svg',
		APP_NAME: 'app.search.photoshop_cc.label',
		APP_DESCRIPTION: 'app.search.photoshop_cc.description',
		APP_ROUTE: '/apps/all/photoshop/overview',
		APP_TAG: ['Photoshop'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/ai_cc_app_RGB.svg',
		APP_NAME: 'app.search.illustrator_cc.label',
		APP_DESCRIPTION: 'app.search.illustrator_cc.description',
		APP_ROUTE: 'apps/all/illustrator/overview',
		APP_TAG: ['Illustrator'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/id_cc_app_RGB.svg',
		APP_NAME: 'app.search.indesign_cc.label',
		APP_DESCRIPTION: 'app.search.indesign_cc.description',
		APP_ROUTE: 'apps/all/indesign/overview',
		APP_TAG: ['InDesign'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/pr_cc_app_RGB.svg',
		APP_NAME: 'app.search.premierepro_cc.label',
		APP_DESCRIPTION: 'app.search.premierepro_cc.description',
		APP_ROUTE: 'apps/all/premiere/overview',
		APP_TAG: ['Premiere', 'premiere-pro'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/ae_cc_app_RGB.svg',
		APP_NAME: 'app.search.aftereffects_cc.label',
		APP_DESCRIPTION: 'app.search.aftereffects_cc.description',
		APP_ROUTE: 'apps/all/aftereffects/overview',
		APP_TAG: ['after-effects', 'After Effects'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/pf_appicon_RGB.svg',
		APP_NAME: 'app.search.portfolio_web.label',
		APP_DESCRIPTION: 'app.search.portfolio_web.description',
		APP_ROUTE: 'apps/all/portfolio-web/overview',
		APP_TAG: ['Portfolio'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/xd_app_RGB_2017.svg',
		APP_NAME: 'app.search.xd_cc.label',
		APP_DESCRIPTION: 'app.search.xd_cc.description',
		APP_ROUTE: 'apps/all/xd/overview',
		APP_TAG: ['XD', 'experience-design'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/lightroom-cc.svg',
		APP_NAME: 'app.search.lightroom_cc.label',
		APP_DESCRIPTION: 'app.search.lightroom_cc.description',
		APP_ROUTE: 'apps/all/lightroom/overview',
		APP_TAG: ['Lightroom', 'Lightroom CC'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/dn_cc_appicon_RGB_noshadow.svg',
		APP_NAME: 'app.search.dimension_cc.label',
		APP_DESCRIPTION: 'app.search.dimension_cc.description',
		APP_ROUTE: 'apps/all/dimension/overview',
		APP_TAG: ['Dimension'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/dw_cc_app_RGB.svg',
		APP_NAME: 'app.search.dreamweaver_cc.label',
		APP_DESCRIPTION: 'app.search.dreamweaver_cc.description',
		APP_ROUTE: 'apps/all/dreamweaver/overview',
		APP_TAG: ['Dreamweaver'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/mu_cc_app_RGB.svg',
		APP_NAME: 'app.search.muse_cc.label',
		APP_DESCRIPTION: 'app.search.muse_cc.description',
		APP_ROUTE: 'apps/all/muse/overview',
		APP_TAG: ['Muse'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/ch_app_RGB.svg',
		APP_NAME: 'app.search.char_animate_cc.label',
		APP_DESCRIPTION: 'app.search.char_animate_cc.description',
		APP_ROUTE: 'apps/all/character-animator/overview',
		APP_TAG: ['Character Animator'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/br_appicon_RGB.svg',
		APP_NAME: 'app.search.bridge_cc.label',
		APP_DESCRIPTION: 'app.search.bridge_cc.description',
		APP_ROUTE: 'apps/all/bridge/overview',
		APP_TAG: ['Bridge'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/an_app_RGB.svg',
		APP_NAME: 'app.search.animate_cc.label',
		APP_DESCRIPTION: 'app.search.animate_cc.description',
		APP_ROUTE: 'apps/all/animate/overview',
		APP_TAG: ['Animate'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/ic_cc_app_RGB.svg',
		APP_NAME: 'app.search.in_copy_cc.label',
		APP_DESCRIPTION: 'app.search.in_copy_cc.description',
		APP_ROUTE: 'apps/all/incopy/overview',
		APP_TAG: ['InCopy'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/au_cc_app_RGB.svg',
		APP_NAME: 'app.search.audition_cc.label',
		APP_DESCRIPTION: 'app.search.audition_cc.description',
		APP_ROUTE: 'apps/all/audition/overview',
		APP_TAG: ['Audition'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/fs_appicon_RGB.svg',
		APP_NAME: 'app.search.fuse_cc.label',
		APP_DESCRIPTION: 'app.search.fuse_cc.description',
		APP_ROUTE: 'apps/all/fuse/overview',
		APP_TAG: ['Fuse'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/Lr_cc_app_noshadow_RGB.svg',
		APP_NAME: 'app.search.lightoom_classic_cc.label',
		APP_DESCRIPTION: 'app.search.lightoom_classic_cc.description',
		APP_ROUTE: 'apps/all/lightroom-classic/overview',
		APP_TAG: ['Lightroom', 'Lightroom Classic'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/me_cc_app_RGB.svg',
		APP_NAME: 'app.search.media_encoder_cc.label',
		APP_DESCRIPTION: 'app.search.media_encoder_cc.description',
		APP_ROUTE: 'apps/all/media-encoder/overview',
		APP_TAG: ['Media Encoder'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/acrobat_dc_app_RGB.svg',
		APP_NAME: 'app.search.arcobat_pro_cc.label',
		APP_DESCRIPTION: 'app.search.arcobat_pro_cc.description',
		APP_ROUTE: 'apps/all/acrobat/overview',
		APP_TAG: ['Acrobat'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/pl_cc_app_RGB.svg',
		APP_NAME: 'app.search.prelude_cc.label',
		APP_DESCRIPTION: 'app.search.prelude_cc.description',
		APP_ROUTE: 'apps/all/prelude/overview',
		APP_TAG: ['Prelude'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/lightroom-cc.svg',
		APP_NAME: 'app.search.lightroom_mobile_cc.label',
		APP_DESCRIPTION: 'app.search.lightroom_mobile_cc.description',
		APP_ROUTE: 'apps/all/lightroom-mobile/overview',
		APP_TAG: ['Lightroom CC'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/creativecloud_mobile_appicon.svg',
		APP_NAME: 'app.search.cc_mobile.label',
		APP_DESCRIPTION: 'app.search.cc_mobile.description',
		APP_ROUTE: 'apps/all/cc-mobile/overviews',
		APP_TAG: ['creative-cloud'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/psexpress_app_RGB.svg',
		APP_NAME: 'app.search.ps_express_mobile_cc.label',
		APP_DESCRIPTION: 'app.search.ps_express_mobile_cc.description',
		APP_ROUTE: 'apps/all/photoshop-express/overview',
		APP_TAG: ['Photoshop Express'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/psfix_app_RGB.svg',
		APP_NAME: 'app.search.ps_fix_mobile_cc.label',
		APP_DESCRIPTION: 'app.search.ps_fix_mobile_cc.description',
		APP_ROUTE: 'apps/all/photoshop-fix/overview',
		APP_TAG: ['Photoshop Fix'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/psmix_app_RGB.svg',
		APP_NAME: 'app.search.ps_mix_mobile_cc.label',
		APP_DESCRIPTION: 'app.search.ps_mix_mobile_cc.description',
		APP_ROUTE: 'apps/all/photoshop-mix/overview',
		APP_TAG: ['Photoshop Mix'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/sketch_app_RGB.svg',
		APP_NAME: 'app.search.ps_sketch_mobile_cc.label',
		APP_DESCRIPTION: 'app.search.ps_sketch_mobile_cc.description',
		APP_ROUTE: 'apps/all/photoshop-sketch/overview',
		APP_TAG: ['Sketch'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/spark_app_RGB_2017.svg',
		APP_NAME: 'app.search.spark_post_mobile.label',
		APP_DESCRIPTION: 'app.search.spark_post_mobile.description',
		APP_ROUTE: 'apps/all/spark-post-mobile/overview',
		APP_TAG: ['Spark Post'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/spark_page_appicon_RGB.svg',
		APP_NAME: 'app.search.spark_page_mobile.label',
		APP_DESCRIPTION: 'app.search.spark_page_mobile.description',
		APP_ROUTE: 'apps/all/spark-page-mobile/overview',
		APP_TAG: ['Spark Page'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/spark_app_RGB_2017.svg',
		APP_NAME: 'app.search.spark_web.label',
		APP_DESCRIPTION: 'app.search.spark_web.description',
		APP_ROUTE: 'apps/all/spark-web/overview',
		APP_TAG: ['Spark'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/be_app_RGB.svg',
		APP_NAME: 'app.search.behance_mobile.label',
		APP_DESCRIPTION: 'app.search.behance_mobile.description',
		APP_ROUTE: 'apps/all/behance-mobile/overview',
		APP_TAG: ['Behance'],
	},
	{
		APP_ICON: 'https://public.adobecc.com/files/1UAKTUIFZSADEZM4UHZ1ICJXCO3FFF/ru_cc_app_RGB.svg',
		APP_NAME: 'app.search.rush.label',
		APP_DESCRIPTION: 'app.search.rush.description',
		APP_ROUTE: 'apps/your-apps/premiere-rush/overview',
		APP_TAG: ['Premiere Rush'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/capture_app_RGB.svg',
		APP_NAME: 'app.search.capture_mobile.label',
		APP_DESCRIPTION: 'app.search.capture_mobile.description',
		APP_ROUTE: 'apps/all/capture/overview',
		APP_TAG: ['Capture'],
	},
	{
		APP_ICON: 'https://public.adobecc.com/files/1UAKTUIFZSADEZM4UHZ1ICJXCO3FFF/creativecloud_appicon_RGB.svg',
		APP_NAME: 'app.search.creative_cloud.label',
		APP_DESCRIPTION: 'app.search.creative_cloud.description',
		APP_ROUTE: 'https://creative.adobe.com/products/download/creative-cloud?trackingid=SPVLMBJQ&mv=in-product',
		APP_TAG: ['creative cloud'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/comp_app_RGB.svg',
		APP_NAME: 'app.search.comp_mobile.label',
		APP_DESCRIPTION: 'app.search.comp_mobile.description',
		APP_ROUTE: 'apps/all/comp/overview',
		APP_TAG: ['Comp'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/draw_app_RGB.svg',
		APP_NAME: 'app.search.illustrator_draw_mobile.label',
		APP_DESCRIPTION: 'app.search.illustrator_draw_mobile.description',
		APP_ROUTE: 'apps/all/illustrator-draw/overview',
		APP_TAG: ['Draw'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/pr-clip.svg',
		APP_NAME: 'app.search.pr_clip_mobile.label',
		APP_DESCRIPTION: 'app.search.pr_clip_mobile.description',
		APP_ROUTE: 'apps/all/premiere-clip/overview',
		APP_TAG: ['Premiere Clip'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/spark_video_app_RGB.svg',
		APP_NAME: 'app.search.spark_video_mobile.label',
		APP_DESCRIPTION: 'app.search.spark_video_mobile.description',
		APP_ROUTE: 'apps/all/spark-video-mobile/overview',
		APP_TAG: ['Spark Video'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/xd_app_RGB_2017.svg',
		APP_NAME: 'app.search.xd_mobile.label',
		APP_DESCRIPTION: 'app.search.xd_mobile.description',
		APP_ROUTE: 'apps/all/xd-mobile/overview',
		APP_TAG: ['XD', 'experience-design'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/be_app_RGB.svg',
		APP_NAME: 'app.search.behance_web.label',
		APP_DESCRIPTION: 'app.search.behance_web.description',
		APP_ROUTE: 'apps/all/behance-web/overview',
		APP_TAG: ['Behance'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/banners/tk_appicon_RGB.svg',
		APP_NAME: 'app.search.typekit_web.label',
		APP_DESCRIPTION: 'app.search.typekit_web.description',
		APP_ROUTE: 'apps/all/typekit-web/overview',
		APP_TAG: ['Typekit'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/st_app_RGB.svg',
		APP_NAME: 'app.search.stock_web.label',
		APP_DESCRIPTION: 'app.search.stock_web.description',
		APP_ROUTE: 'apps/all/stock-web/overview',
		APP_TAG: ['Stock'],
	},
	{
		APP_ICON: 'https://cvs.adobe.com/content/dam/cvs/cchome/mnemonics/Lr_cc_appicon_noshadow_2017.svg',
		APP_NAME: 'app.search.lightroom_web.label',
		APP_DESCRIPTION: 'app.search.lightroom_web.description',
		APP_ROUTE: 'apps/all/lightroom-web/overview',
		APP_TAG: ['Lightroom Web'],
	},
];

export const clientID = getConfig('CLIENT_ID');
